import React from "react";

import { useTranslation } from "react-i18next";

import useLocale from "@/hooks/useLocale";

interface FooterProps {
  isSurvey?: boolean;
}

const Footer = ({ isSurvey = false }: FooterProps) => {
  const { t } = useTranslation();
  const locale = useLocale();

  const rules_and_regs_file_url = {
    en: `/2025_Ford_EV_Road_Trip of_a_Lifetime_Contest_Rules_(ON-QC-BC).pdf`,
    fr: `/2025_La_Grande_Aventure_Electrique_Ford_(ON-QC-BC_FR).pdf`,
  }[locale];

  const concierge_plus_rules_and_regs_file_url = {
    en: `/2025_Ford_ConciergePlus_Contest_Rules_(ON-QC-BC).pdf`,
    fr: `/2025_Concours_Ford_ConciergePlus_(ON-QC-BC_FR).pdf`,
  }[locale];

  return (
    <div className="bg-[#F0F0F0] pb-[5rem] pt-10">
      <a
        href={rules_and_regs_file_url}
        target="_blank"
        className="block text-center text-ford-blue font-roboto font-bold text-md md:text-lg cursor-pointer"
        dangerouslySetInnerHTML={{ __html: t("footer.title") }}
      />

      {isSurvey && (
        <a
          href={concierge_plus_rules_and_regs_file_url}
          target="_blank"
          className="block text-center text-ford-blue font-roboto font-bold text-lg cursor-pointer mt-[30px]"
        >
          {t("footer.concierge_plus_rules_and_regs")}
        </a>
      )}

      <div className="border-b border-blue mt-4 mb-6 mx-10" />

      <small className="text-center w-full block text-[14px]">
        {t("footer.credits")}
      </small>
    </div>
  );
};

export default Footer;
